import { useParams, useLocation } from "react-router-dom";
import { getJwtRoleSlug } from "../../public/utils/jwtRole";

/** Role slug from /:roleSlug/... route, /<basePath>/dashboard, or JWT. */
export function useEffectiveRoleSlug() {
  const { roleSlug } = useParams();
  const location = useLocation();

  if (roleSlug) return roleSlug;

  const segment = location.pathname.split("/").filter(Boolean)[0];
  if (segment) return segment;

  if (typeof localStorage !== "undefined") {
    return getJwtRoleSlug(localStorage.getItem("jwt_token")) || "";
  }
  return "";
}
